<template>
  <v-container
    class="secondary-market-orders-view-container"
    fluid
  >
    <h1>Secondary Market Orders</h1>
    <secondary-market-orders-table
      :secondary-market-orders="secondaryMarketOrders"
      :secondary-market-orders-pagination="pagination"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import { SecondaryMarketOrdersTable } from '@/components/baader';

export default {
  name: 'SecondaryMarketOrders',
  components: {
    'secondary-market-orders-table': SecondaryMarketOrdersTable,
  },
  computed: {
    ...mapState({
      loading: state => state.secondaryMarketOrdersStore.loading,
      secondaryMarketOrders: state => state.secondaryMarketOrdersStore.secondaryMarketOrders,
      pagination: state => state.secondaryMarketOrdersStore.pagination,
    }),
  },
  async mounted() {
    this.getSecondaryMarketOrders(toQueryString({ sort: 'created_at', dir: 'desc', page: 1, limit: 25 }));
  },
  methods: {
    ...mapActions(['getSecondaryMarketOrders']),
  },
};
</script>


<style lang="scss" scoped>
.secondary-market-orders-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/baader/SecondaryMarketOrders.vue